import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1100px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            用户评价
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            来自真实用户的观影体验分享，加入丁香花影院的追剧大家庭
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7"
            >
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-5">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400 flex items-center gap-2">
                    <span>{item.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="truncate">{item.source}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.slice(3).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-7"
            >
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-5">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400 flex items-center gap-2">
                    <span>{item.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="truncate">{item.source}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}